import cssVariables from 'tfs.css-variables'

export default {
  wrapper: {
    overflowY: 'auto',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 80,
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  modal: {
    width: '100%',
    minHeight: 'calc(100% - 7.5rem)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '7.5rem',
  },
  content: {
    zIndex: 1,
    borderRadius: '0.5em',
    backgroundColor: cssVariables.colorWhite,
  },
}
